// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* 📌 General Modal Styling */
.ModalBodyStyle {
  display: flex;
  flex-direction: column;
  padding: 20px;
  background-color: #f7f7f7;
  border-radius: 8px;
  position: relative;
}

.ModalHeader {
  margin-bottom: 20px;
  padding-bottom: 20px;
  border-bottom: 1px solid #ddd;
}

.ModalTitle {
  font-size: 24px;
  font-weight: 700;
  color: #12394d;
  margin-bottom: 10px;
  font-family: "Roboto Slab", serif;
}

.ModalDate,
.ModalDescription,
.ModalPages {
  font-size: 14px;
  font-weight: 400;
  color: #666;
  margin-bottom: 10px;
}

.ModalDescription {
  font-size: 16px;
  color: #333;
}

/* 📌 Split View between Text and PDF Viewer */
.SplitView {
  display: flex;
  height: 70vh;
  gap: 16px;
}

/* 📌 Common Text Containers (Arabic & Translated) */
.ArabicTextContainer,
.TranslatedTextContainer {
  flex: 1 1;
  padding: 16px;
  overflow-y: auto;
  border-right: 1px solid #ddd;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
}

/* 📌 Arabic & Translated Text Blocks */
.ArabicTextBlock,
.TranslatedTextBlock {
  font-size: 18px;
  font-weight: 400;
  color: #333;
  line-height: 1.6;
  padding: 15px;
  border-radius: 8px;
}

/* Arabic-specific styles */
.ArabicTextBlock {
  text-align: right;
  direction: rtl;
}

/* Translated text (LTR) */
.TranslatedTextBlock {
  text-align: left;
  direction: ltr;
}

/* 📌 Highlighted Search Terms */
.highlight {
  background-color: yellow;
  font-weight: bold;
  padding: 2px;
  border-radius: 3px;
}

/* 📌 PDF Viewer */
.PdfViewerContainer {
  display: flex;
  flex-direction: column;
  flex: 2 1;
  height: 100%;
  padding: 16px;
  background-color: #fff;
  border-left: 1px solid #ddd;
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
}

/* 📌 Text Line Styling */
.TextLine {
  padding: 8px;
  cursor: pointer;
  border-bottom: 1px solid #eee;
  text-align: right;
  direction: rtl;
}

.TextLine:hover {
  background-color: #f8f9fa;
}

.TextLine.selected {
  background-color: #e9ecef;
}

.TextLine.highlighted {
  background-color: #fff3cd;
}

/* 📌 Align Dropdown & Translate Button */
.TranslationControls {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 20px;
}

.LanguageDropdown,
.TranslateButton {
  height: 40px;
}

.ButtonRow {
  display: flex;
  gap: 10px;
  justify-content: flex-start;
  align-items: center;
  margin-bottom: 10px;
  border-bottom: 1px solid #ddd;
  padding-bottom: 12px;
}

.ActionButton {
  font-size: 14px;
  padding: 6px 12px;
  border-radius: 4px;
  background-color: none !important; /* Bootstrap primary */
  color: #0d6efd !important;
  border: 1px solid #0d6efd !important;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background-color 0.2s, color 0.2s;
}

.ActionButton:hover {
  background-color: #0d6efd !important;
  color: #fff !important;
  border: 1px solid #0d6efd !important;
}

/* Even smaller buttons on tablets */
@media (max-width: 768px) {
  .DownloadButton {
    font-size: 10px;
    padding: 5px 10px;
    min-width: 130px;
    max-width: 180px;
  }
}

/* Extra small buttons for mobile */
@media (max-width: 480px) {
  .DownloadButton {
    font-size: 9px;
    padding: 4px 8px;
    min-width: 120px;
    max-width: 160px;
  }
}

/* 📌 Modal Footer & Close Button */
.FooterStyle {
  display: flex;
  justify-content: flex-end;
  padding: 20px;
  border-top: 1px solid #ddd;
}

.FeedbackButton {
  background-color: #0d6efd;
  color: #fff;
  padding: 10px 18px;
  border: none;
  border-radius: 5px;
  font-size: 16px;
  cursor: pointer;
  margin-right: 10px;
}

.FeedbackButton:hover {
  background-color: #0b5ed7;
  color: #fff;
}

.CloseButton {
  background-color: #cc0000;
  color: #fff;
  padding: 10px 20px;
  border: none;
  border-radius: 5px;
  font-size: 16px;
  cursor: pointer;
  transition: background-color 0.3s ease;
}

.CloseButton:hover {
  background-color: #a30000;
}

.FeedbackSummary {
  display: flex;
  flex-direction: column;
  gap: 6px;
  font-size: 14px;
  color: #333;
  margin-bottom: 12px;
}

.FeedbackPaneInline {
  flex: 0 0 320px;
  max-width: 360px;
  min-width: 280px;
  height: 100%;
  background: #fff;
  border-left: 1px solid #ddd;
  border-radius: 8px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.08);
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.FeedbackPaneHeader {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 4px;
}

.FeedbackPaneActions {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  margin-top: auto;
}

.navigation-controls {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 10px;
  padding: 10px;
  background: #fff;
  border-bottom: 1px solid #ddd;
}

.navigation-controls .nav-group {
  display: flex;
  align-items: center;
  gap: 10px;
}

.navigation-controls .btn {
  min-width: 40px;
  height: 35px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.navigation-controls .btn:hover:not(:disabled) {
  background-color: #f0f0f0;
}

.navigation-controls span {
  font-size: 14px;
  color: #333;
  padding: 0 10px;
}

.page-indicator {
  display: flex;
  align-items: center;
  gap: 6px;
}

.InlinePageInput {
  width: 60px;
  padding: 2px 6px;
  font-size: 13px;
  text-align: center;
}

.view-toggle-container {
  display: flex;
  justify-content: flex-end;
  margin-left: auto;
}

.view-toggle-switch {
  font-size: 0.8rem;
}

/* Custom styling for the switch */
.view-toggle-switch .form-check-input {
  width: 2.5em;
  height: 1.25em;
  margin-right: 8px;
}

.view-toggle-switch .form-check-input:checked {
  background-color: #0d6efd;
  border-color: #0d6efd;
}

.pdf-viewer-toolbar {
  display: flex;
  width: 100%;
  justify-content: center;
  align-items: center;
  gap: 1rem;
  margin: 0 auto;
}

.pdf-viewer-toolbar__group {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.pdf-viewer-toolbar-wrapper {
  display: flex;
  width: 100%;
  justify-content: center;
}


.pdf-viewer-toolbar {
  display: flex;
  width: 100%;
  justify-content: center;
  align-items: center;
  gap: 1rem;
  margin: 0 auto;
}

.pdf-viewer-toolbar__group {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.pdf-viewer-toolbar-wrapper {
  display: flex;
  width: 100%;
  justify-content: center;
}
`, "",{"version":3,"sources":["webpack://./src/styles/pdf-modal.css"],"names":[],"mappings":"AAAA,6BAA6B;AAC7B;EACE,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,6BAA6B;AAC/B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,iCAAiC;AACnC;;AAEA;;;EAGE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA,8CAA8C;AAC9C;EACE,aAAa;EACb,YAAY;EACZ,SAAS;AACX;;AAEA,oDAAoD;AACpD;;EAEE,SAAO;EACP,aAAa;EACb,gBAAgB;EAChB,4BAA4B;EAC5B,aAAa;EACb,sBAAsB;EACtB,2BAA2B;AAC7B;;AAEA,uCAAuC;AACvC;;EAEE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,kBAAkB;AACpB;;AAEA,2BAA2B;AAC3B;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA,0BAA0B;AAC1B;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA,gCAAgC;AAChC;EACE,wBAAwB;EACxB,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;AACpB;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,sBAAsB;EACtB,SAAO;EACP,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,2BAA2B;EAC3B,0CAA0C;AAC5C;;AAEA,yBAAyB;AACzB;EACE,YAAY;EACZ,eAAe;EACf,6BAA6B;EAC7B,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,yCAAyC;AACzC;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;;AAEA;;EAEE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,SAAS;EACT,2BAA2B;EAC3B,mBAAmB;EACnB,mBAAmB;EACnB,6BAA6B;EAC7B,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,iCAAiC,EAAE,sBAAsB;EACzD,yBAAyB;EACzB,oCAAoC;EACpC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,6CAA6C;AAC/C;;AAEA;EACE,oCAAoC;EACpC,sBAAsB;EACtB,oCAAoC;AACtC;;AAEA,oCAAoC;AACpC;EACE;IACE,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,gBAAgB;EAClB;AACF;;AAEA,mCAAmC;AACnC;EACE;IACE,cAAc;IACd,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;EAClB;AACF;;AAEA,mCAAmC;AACnC;EACE,aAAa;EACb,yBAAyB;EACzB,aAAa;EACb,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,eAAe;EACf,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;EAChB,2BAA2B;EAC3B,kBAAkB;EAClB,0CAA0C;EAC1C,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;EACT,aAAa;EACb,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA,kCAAkC;AAClC;EACE,YAAY;EACZ,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,WAAW;EACX,uBAAuB;AACzB;;;AAGA;EACE,aAAa;EACb,WAAW;EACX,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,WAAW;EACX,uBAAuB;AACzB","sourcesContent":["/* 📌 General Modal Styling */\n.ModalBodyStyle {\n  display: flex;\n  flex-direction: column;\n  padding: 20px;\n  background-color: #f7f7f7;\n  border-radius: 8px;\n  position: relative;\n}\n\n.ModalHeader {\n  margin-bottom: 20px;\n  padding-bottom: 20px;\n  border-bottom: 1px solid #ddd;\n}\n\n.ModalTitle {\n  font-size: 24px;\n  font-weight: 700;\n  color: #12394d;\n  margin-bottom: 10px;\n  font-family: \"Roboto Slab\", serif;\n}\n\n.ModalDate,\n.ModalDescription,\n.ModalPages {\n  font-size: 14px;\n  font-weight: 400;\n  color: #666;\n  margin-bottom: 10px;\n}\n\n.ModalDescription {\n  font-size: 16px;\n  color: #333;\n}\n\n/* 📌 Split View between Text and PDF Viewer */\n.SplitView {\n  display: flex;\n  height: 70vh;\n  gap: 16px;\n}\n\n/* 📌 Common Text Containers (Arabic & Translated) */\n.ArabicTextContainer,\n.TranslatedTextContainer {\n  flex: 1;\n  padding: 16px;\n  overflow-y: auto;\n  border-right: 1px solid #ddd;\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start;\n}\n\n/* 📌 Arabic & Translated Text Blocks */\n.ArabicTextBlock,\n.TranslatedTextBlock {\n  font-size: 18px;\n  font-weight: 400;\n  color: #333;\n  line-height: 1.6;\n  padding: 15px;\n  border-radius: 8px;\n}\n\n/* Arabic-specific styles */\n.ArabicTextBlock {\n  text-align: right;\n  direction: rtl;\n}\n\n/* Translated text (LTR) */\n.TranslatedTextBlock {\n  text-align: left;\n  direction: ltr;\n}\n\n/* 📌 Highlighted Search Terms */\n.highlight {\n  background-color: yellow;\n  font-weight: bold;\n  padding: 2px;\n  border-radius: 3px;\n}\n\n/* 📌 PDF Viewer */\n.PdfViewerContainer {\n  display: flex;\n  flex-direction: column;\n  flex: 2;\n  height: 100%;\n  padding: 16px;\n  background-color: #fff;\n  border-left: 1px solid #ddd;\n  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);\n}\n\n/* 📌 Text Line Styling */\n.TextLine {\n  padding: 8px;\n  cursor: pointer;\n  border-bottom: 1px solid #eee;\n  text-align: right;\n  direction: rtl;\n}\n\n.TextLine:hover {\n  background-color: #f8f9fa;\n}\n\n.TextLine.selected {\n  background-color: #e9ecef;\n}\n\n.TextLine.highlighted {\n  background-color: #fff3cd;\n}\n\n/* 📌 Align Dropdown & Translate Button */\n.TranslationControls {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  margin-bottom: 20px;\n}\n\n.LanguageDropdown,\n.TranslateButton {\n  height: 40px;\n}\n\n.ButtonRow {\n  display: flex;\n  gap: 10px;\n  justify-content: flex-start;\n  align-items: center;\n  margin-bottom: 10px;\n  border-bottom: 1px solid #ddd;\n  padding-bottom: 12px;\n}\n\n.ActionButton {\n  font-size: 14px;\n  padding: 6px 12px;\n  border-radius: 4px;\n  background-color: none !important; /* Bootstrap primary */\n  color: #0d6efd !important;\n  border: 1px solid #0d6efd !important;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: background-color 0.2s, color 0.2s;\n}\n\n.ActionButton:hover {\n  background-color: #0d6efd !important;\n  color: #fff !important;\n  border: 1px solid #0d6efd !important;\n}\n\n/* Even smaller buttons on tablets */\n@media (max-width: 768px) {\n  .DownloadButton {\n    font-size: 10px;\n    padding: 5px 10px;\n    min-width: 130px;\n    max-width: 180px;\n  }\n}\n\n/* Extra small buttons for mobile */\n@media (max-width: 480px) {\n  .DownloadButton {\n    font-size: 9px;\n    padding: 4px 8px;\n    min-width: 120px;\n    max-width: 160px;\n  }\n}\n\n/* 📌 Modal Footer & Close Button */\n.FooterStyle {\n  display: flex;\n  justify-content: flex-end;\n  padding: 20px;\n  border-top: 1px solid #ddd;\n}\n\n.FeedbackButton {\n  background-color: #0d6efd;\n  color: #fff;\n  padding: 10px 18px;\n  border: none;\n  border-radius: 5px;\n  font-size: 16px;\n  cursor: pointer;\n  margin-right: 10px;\n}\n\n.FeedbackButton:hover {\n  background-color: #0b5ed7;\n  color: #fff;\n}\n\n.CloseButton {\n  background-color: #cc0000;\n  color: #fff;\n  padding: 10px 20px;\n  border: none;\n  border-radius: 5px;\n  font-size: 16px;\n  cursor: pointer;\n  transition: background-color 0.3s ease;\n}\n\n.CloseButton:hover {\n  background-color: #a30000;\n}\n\n.FeedbackSummary {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  font-size: 14px;\n  color: #333;\n  margin-bottom: 12px;\n}\n\n.FeedbackPaneInline {\n  flex: 0 0 320px;\n  max-width: 360px;\n  min-width: 280px;\n  height: 100%;\n  background: #fff;\n  border-left: 1px solid #ddd;\n  border-radius: 8px;\n  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.08);\n  padding: 16px;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.FeedbackPaneHeader {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 4px;\n}\n\n.FeedbackPaneActions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 10px;\n  margin-top: auto;\n}\n\n.navigation-controls {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 10px;\n  padding: 10px;\n  background: #fff;\n  border-bottom: 1px solid #ddd;\n}\n\n.navigation-controls .nav-group {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.navigation-controls .btn {\n  min-width: 40px;\n  height: 35px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.navigation-controls .btn:hover:not(:disabled) {\n  background-color: #f0f0f0;\n}\n\n.navigation-controls span {\n  font-size: 14px;\n  color: #333;\n  padding: 0 10px;\n}\n\n.page-indicator {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.InlinePageInput {\n  width: 60px;\n  padding: 2px 6px;\n  font-size: 13px;\n  text-align: center;\n}\n\n.view-toggle-container {\n  display: flex;\n  justify-content: flex-end;\n  margin-left: auto;\n}\n\n.view-toggle-switch {\n  font-size: 0.8rem;\n}\n\n/* Custom styling for the switch */\n.view-toggle-switch .form-check-input {\n  width: 2.5em;\n  height: 1.25em;\n  margin-right: 8px;\n}\n\n.view-toggle-switch .form-check-input:checked {\n  background-color: #0d6efd;\n  border-color: #0d6efd;\n}\n\n.pdf-viewer-toolbar {\n  display: flex;\n  width: 100%;\n  justify-content: center;\n  align-items: center;\n  gap: 1rem;\n  margin: 0 auto;\n}\n\n.pdf-viewer-toolbar__group {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.pdf-viewer-toolbar-wrapper {\n  display: flex;\n  width: 100%;\n  justify-content: center;\n}\n\n\n.pdf-viewer-toolbar {\n  display: flex;\n  width: 100%;\n  justify-content: center;\n  align-items: center;\n  gap: 1rem;\n  margin: 0 auto;\n}\n\n.pdf-viewer-toolbar__group {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.pdf-viewer-toolbar-wrapper {\n  display: flex;\n  width: 100%;\n  justify-content: center;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
